import { LevelSurfacesLoadingPage } from "@-/dev.improve.haniverse.routes.nav.app._components.level.surface";
import { LazyBrowseTabContent } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs._lib.focus";
import { PrimaryControlsStripTitle } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.title";
import { BrowseCharactersPrimaryControlsStripExpansionContent } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.characters._components.primary-controls-strip-expansion-content";
import { CharactersToolbar } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.characters._components.toolbar";
import { SuspensePageBoundary } from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { PrimaryControlsStripBack } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.back";
import { Slot, usePathname } from "@-/com.npmjs.expo-router";
import { View } from "@-/com.npmjs.react-native";
import { PrimaryControlsStripAccordion } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.toolbar";
import { GlassHeaderOverlapContext } from "@-/dev.improve.haniverse.components.ui.header-scroll";
import { useToolbarGridMetrics } from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";
import { FrostedBackdropTarget } from "@-/dev.improve.haniverse.components.ui.frosted-surface";

/**
 * Shared chrome for every Characters sub-route (index / Rank / HSK / TBCL): the nav header, the
 * dataset progress expansion, and a suspense boundary around the route body rendered into the
 * `Slot`. The route switcher pills and view/sort/filter controls live in the floating
 * `CharactersToolbar` rendered by each body view, so they overlay the character list.
 */
export function BrowseCharactersLayout() {
  const pathname = usePathname();
  const active = pathname.endsWith("/characters")
    ? null
    : pathname.includes("/grade/")
      ? "grade"
      : "rank";
  // The grade catalogs pin opaque tabs or accordion headers under the bar; the others scroll their
  // lists beneath it, which on iOS 26 float the bar as glass over them.
  const isFloating = active !== "grade";
  const { height: toolbarHeight } = useToolbarGridMetrics();
  return (
    <>
      <PrimaryControlsStripBack hidden />
      <LazyBrowseTabContent>
        <BrowseCharactersPrimaryControlsStripExpansionContent />
      </LazyBrowseTabContent>
      <PrimaryControlsStripTitle>Characters</PrimaryControlsStripTitle>
      <View className="flex-1 bg-background">
        <FrostedBackdropTarget className="flex-1">
          <GlassHeaderOverlapContext value={isFloating ? toolbarHeight : undefined}>
            <SuspensePageBoundary
              fallback={<LevelSurfacesLoadingPage hasFloatingToolbar />}
              location={import.meta.location}
            >
              <LazyBrowseTabContent fallback={<LevelSurfacesLoadingPage hasFloatingToolbar />}>
                <Slot />
              </LazyBrowseTabContent>
            </SuspensePageBoundary>
          </GlassHeaderOverlapContext>
        </FrostedBackdropTarget>
        <PrimaryControlsStripAccordion
          className="absolute inset-x-0 top-0 z-10"
          floating={isFloating}
          hasLeadingActions
          stripFade={isFloating}
        >
          <CharactersToolbar active={active} />
        </PrimaryControlsStripAccordion>
      </View>
    </>
  );
}
